<div class="obg-m-quick-sga-login-content">
	<ng-container *ngIf="polling else imgContent">
		<mat-spinner color="primary" diameter="80"></mat-spinner>
		<div class="obg-m-quick-sga-login-message">{{ 'sga-login-transaction.polling' | translate }}</div>
	</ng-container>
	<ng-template #imgContent>
		<div class="obg-m-quick-sga-login-image">
			<img [obgImageContent]="showError && errorMessage ? 'general.bankid.error' : 'general.bankid'" />
		</div>
		<div class="obg-m-quick-sga-login-message">
			{{ (showError && errorMessage ? errorMessage : 'sga-login-transaction.short-description' ) | translate }}
			<strong *ngIf="customerCanLogInAt">{{ customerCanLogInAt }}</strong>
		</div>
	</ng-template>
</div>
<div class="obg-m-quick-sga-login-actions">
	<div class="obg-m-quick-sga-login-cancel" *ngIf="polling; else formEnabledView">
		<span [hidden]="hideCancelButton" (click)="submitCancel()" class="obg-m-quick-sga-login-cancel-button">
			{{ 'general.cancel' | translate }}
		</span>
	</div>
	<ng-template #formEnabledView>
		<button
			mat-flat-button
			color="accent"
			class="primary-button"
			(click)="login()"
			test-id="login-submit"
			data-test-id="login-submit"
			[disabled]="polling"
		>
			{{ primaryButtonTranslationKey | translate }}
		</button>
		<ng-content select="secondary-button"></ng-content>
	</ng-template>
</div>
